module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-LightItalic.77c3ef3.woff";